import { useAnalyticsSetup } from '@doda/common/src/hooks/useAnalytics';
import { useCmsMemberInfo } from '@doda/common/src/hooks/useCmsMemberInfo';
import { usePvCountUp } from '../usePvCountUp';

/**
 * クライアントでの画面初期化処理
 * @param jid string 求人ID
 * @param wmuid string 原稿ID
 */
export function useInitializeOnClient({
  jid,
  wmuid,
}: {
  jid: string;
  wmuid: string;
}) {
  useCmsMemberInfo('loginStatus');
  useAnalyticsSetup({ isNeedNormalize: false });
  usePvCountUp({ jid, wmuid });
}
